import { PARAGRAPH_LIMIT, SENTENCE_LIMIT } from '../../store/editorUtils';

export interface getFormattedEditorLimitsProps {
  charactersUsed: number;
  sentencesUsed: number;
  paragraphsUsed: number;
  characterLimit: number;
  renderMode: string;
}

export interface FormattedEditorLimits {
  counter: string;
  a11yCounterLiveLabel: string;
  a11yCounterStaticLabel: string;
  tooltip?: string;
}

const COUNT_THRESHOLD = 1;

export const getFormattedEditorLimits = (
  inputs: getFormattedEditorLimitsProps
): FormattedEditorLimits => {
  const {
    charactersUsed,
    sentencesUsed,
    paragraphsUsed,
    characterLimit,
    renderMode,
  } = inputs;

  let counter = '';
  let a11yCounterLiveLabel = '';
  let a11yCounterStaticLabel = '';
  let tooltipTitle = '';
  let shouldShowTooltip = false;

  switch (renderMode) {
    case 'all': {
      const charactersLeft = Math.max(characterLimit - charactersUsed, 0);
      a11yCounterLiveLabel = `${charactersLeft} characters left`;
      a11yCounterStaticLabel = `${charactersUsed} of ${characterLimit} characters used`;

      counter = `(${charactersUsed} / ${characterLimit}) characters`;
      shouldShowTooltip = charactersUsed / characterLimit >= COUNT_THRESHOLD;
      tooltipTitle = `Max of ${characterLimit} while using Single Take render option.`;
      break;
    }
    case 'paragraph': {
      const paragraphsLeft = Math.max(PARAGRAPH_LIMIT - paragraphsUsed, 0);
      a11yCounterLiveLabel = `${paragraphsLeft} paragraphs left`;
      a11yCounterStaticLabel = `${charactersUsed} characters used, ${paragraphsUsed} of ${PARAGRAPH_LIMIT} sentences used`;

      counter = `(${charactersUsed}) characters, (${paragraphsUsed} / ${PARAGRAPH_LIMIT}) paragraphs`;
      shouldShowTooltip = paragraphsUsed / PARAGRAPH_LIMIT >= COUNT_THRESHOLD;
      tooltipTitle = `Max of ${PARAGRAPH_LIMIT} paragraphs while using Paragraph render option`;
      break;
    }
    case 'sentence': {
      const sentencesLeft = Math.max(SENTENCE_LIMIT - sentencesUsed, 0);
      a11yCounterLiveLabel = `${sentencesLeft} sentences left`;
      a11yCounterStaticLabel = `${charactersUsed} characters used, ${sentencesUsed} of ${SENTENCE_LIMIT} sentences used`;

      counter = `(${charactersUsed}) characters, (${sentencesUsed} / ${SENTENCE_LIMIT}) sentences`;
      shouldShowTooltip = sentencesUsed / SENTENCE_LIMIT >= COUNT_THRESHOLD;
      tooltipTitle = `Max of ${SENTENCE_LIMIT} setences while using Sentence render option`;
      break;
    }
    default:
      break;
  }

  return {
    counter,
    a11yCounterLiveLabel,
    a11yCounterStaticLabel,
    tooltip: (shouldShowTooltip && tooltipTitle) || undefined,
  };
};

export default {
  getFormattedEditorLimits,
};
